/* istanbul ignore file */
import { getConfig } from "./config.utils";

export function showDebugTools() {
  return getConfig().SHOW_DEBUG_TOOLS;
}
